import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeroSection = styled.div`
  text-align: center;
  padding: 4rem 0;
`;

const Home = () => {
  return (
    <Container>
      <HeroSection>
        <Typography variant="h2" gutterBottom>
          千里马-创建专业的简历
        </Typography>
        <Typography variant="h5" color="textSecondary" paragraph>
          使用我们的简历制作工具，轻松创建专业的简历
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          component={Link}
          to="/builder"
        >
          开始制作
        </Button>
      </HeroSection>
    </Container>
  );
};

export default Home; 